import {SetCompanySelection} from "../storage/CompanySelection";
import { SetLoginPortals } from "../storage/LogInPortals";
import { WorkforceClinicPortal } from "../AppState";

export interface CompanySelectedPayload{
    participationId: string,
    Link: string
}

export interface CompanyUpdatePayload{
  ForceReload: boolean
}

export interface AllowCompanySelectionPayload{
  showSelection: boolean
}

export type COMPANY_SELECTED_TYPE = 'COMPANY_SELECTED';
export const COMPANY_SELECTED = 'COMPANY_SELECTED';

export type COMPANY_UPDATED_TYPE = 'COMPANY_UPDATED';
export const COMPANY_UPDATED = 'COMPANY_UPDATED';

export type CLINIC_LIST_UPDATED_TYPE = 'CLINIC_LIST_UPDATED';
export const CLINIC_LIST_UPDATED = 'CLINIC_LIST_UPDATED';

export type ALLOW_COMPANY_SELECTION_TYPE = 'ALLOW_COMPANY_SELECTION';
export const ALLOW_COMPANY_SELECTION = 'ALLOW_COMPANY_SELECTION';

export interface CompanySelectedAction{
    type: COMPANY_SELECTED_TYPE
    payload: CompanySelectedPayload
}

export interface CompanyUpdateAction{
  type: COMPANY_UPDATED_TYPE
  payload: CompanyUpdatePayload
}

export interface ClinicListUpdatedPayload{
  Clinic: WorkforceClinicPortal[]
}

interface ClinicListUpdatedAction {
  type: CLINIC_LIST_UPDATED_TYPE
  payload: ClinicListUpdatedPayload
}

export interface AllowCompanySelectionAction{
  type: ALLOW_COMPANY_SELECTION_TYPE
  payload: AllowCompanySelectionPayload
}

export function WorkforceReloadPortalsCompanies(forceReload: boolean = false): CompanyUpdateAction {
  return {
      type: COMPANY_UPDATED,
      payload: { ForceReload: forceReload }
  }
}

export function CompanyUpdated(data: ClinicListUpdatedPayload | null): ClinicListUpdatedAction {
  if(data && data.Clinic){
    SetLoginPortals(data.Clinic)
  }
  return {
    type: CLINIC_LIST_UPDATED,
    payload: {Clinic: data?.Clinic || []}
  }
}

export function SelectCompany(participationId: string, logInLink: string): CompanySelectedAction{
    SetCompanySelection(participationId, logInLink);
    return {
        type: COMPANY_SELECTED,
        payload: {
            participationId,
            Link: logInLink
        }
    };
}

export function AllowSelectCompany(): AllowCompanySelectionAction{
  return {
      type: ALLOW_COMPANY_SELECTION,
      payload: {
          showSelection: true
      }
  };
}

export type WorkforceClinicActions = | CompanySelectedAction | AllowCompanySelectionAction | CompanyUpdateAction | ClinicListUpdatedAction;
